<template>
  <div class="mainContainer" id="caregiver-history-table">
    <el-row>
      <div class="header-36-black">ประวัติการทํางานกับ เฮลท์ แอท โฮม</div>
    </el-row>
    <el-col :span="1.1">
      <el-row class="subheader-container" style="border-radius: 3.6px;">
        <div class="subheader title">เคส: &nbsp;</div>
        <div class="subheader detail">{{ caregiverHistory.cases }}</div>
        <div class="subheader title">เวรที่แมทช ์: &nbsp;</div>
        <div class="subheader detail">{{ caregiverHistory.matchedShifts }}</div>
        <div class="subheader title">เวรที่ทำแล้ว: &nbsp;</div>
        <div class="subheader detail" v-if="caregiverHistory.caregiverType === 'CGN'">{{ caregiverHistory.shifts }}</div>
        <div class="subheader detail last" v-if="caregiverHistory.caregiverType !== 'CGN'">{{ caregiverHistory.shifts }}</div>
        <div class="subheader title" v-if="caregiverHistory.caregiverType === 'CGN'">CGNเวรที่เหลือ: &nbsp;</div>
        <div class="subheader detail last" v-if="caregiverHistory.caregiverType === 'CGN'">{{ caregiverHistory.quotaShiftsLeft }}</div>
      </el-row>
    </el-col>
    <el-table id="caregiver-history" :data="displayHistoryList" :span-method="objectSpanMethod" style="width: 100%;">
      <el-table-column prop="label" label="เลขลูกค้า" width="590"></el-table-column>
      <el-table-column label="บุ๊คกิ้ง" width="100"><template slot-scope="scope"><div class="booking-page not-hover"><div class="id">&nbsp;</div><div class="range">รวมเวร</div><div class="shifts">{{ scope.row.bookings.reduce((sum, booking) => parseInt(sum) + parseInt(booking.shifts), 0) }}</div></div><div class="booking-page" v-for="(booking, index) in scope.row.bookings" :key="'booking ' + index" @click="rowClick(booking)"><div class="id">{{ booking.label }}</div><div class="range">{{ booking.range }}</div><div class="shifts">{{ booking.shifts }}</div></div></template></el-table-column>
      <el-table-column
          label="ระยะเวลา"
          width="230"
      ></el-table-column>
      <el-table-column label="เวร" min-width="100"></el-table-column>
    </el-table>
    <el-pagination class="pageination-right" :current-page.sync="page" layout="prev, pager, next" :total="totalPage"></el-pagination>
  </div>
</template>

<script>
export default {
  name: 'CaregiverHistory',
  props: {
    caregiverHistory: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      page: 1,
    }
  },
  computed: {
    totalPage () {
      return Math.ceil((this.caregiverHistory.list.length / 3) * 10)
    },
    displayHistoryList () {
      const item = this.page * 3
      return this.caregiverHistory.list.slice(item - 3, item)
    },
  },
  methods: {
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return [1, 3]
      } else if (columnIndex === 1) {
        return [0, 0]
      }
    },
    rowClick (booking) {
      this.$router.push({ name: 'PatientDetail', params: { id: booking.label.split('.')[0] }, query: { tab: 'workcalendarTab' } })
    },
  },
}
</script>

<style lang='scss'>
  .el-table__body tbody tr td {
    vertical-align: text-top;
  }

  p, .booking {
    line-height: 41px;
  }

  .el-table#caregiver-history th > .cell {
    font-family: 'Sukhumvit-Bold';
  }
</style>

<style lang='scss' scoped>
  .mainContainer {
    padding: 100px 40px;
  }

  .el-table, .el-table {
    td, th {
      text-overflow: ellipsis;
    overflow: hidden;
    }
  }

  .subheader-container {
    display: flex;
    flex-direction: row;
    margin: 32px 0;
    background: #f5f7fa;
    padding: 5px 18px 6px 14px;
  }

  .subheader {
    font-size: 18px;
    font-weight: 900;
  }

  .title {
    font-family: 'Sukhumvit-Medium';
    color: #606266;
    line-height: 150%;
  }

  .detail {
    color: #606266;
    margin-right: 34px;
    line-height: 150%;
  }

  .last {
    margin-right: 0;
  }

  .el-table__body {
    overflow-wrap: break-word;
  }

  .pageination-right {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px !important;
  }

  .booking-page {
    display: flex;
    flex-direction: row;
    min-width: 400px;
    max-width: 400px;
    padding: 16px 24px;
    margin-left: -24px;
    font-family: 'Sukhumvit-Medium';
    color: #A2A7B3;

    .id {
      min-width: 100px;
    }

    .range {
      min-width: 230px;
    }

    .shifts {
      min-width: 10px;
    }

    &:hover {
      background: #F1F3F6;
      cursor: pointer;
    }

    &.not-hover {
      color: #434B61;

      .range {
        text-align: right;
        padding-right: 23px;
      }

      &:hover {
        background: #FFFFFF;
        cursor: auto;
      }
    }
  }
</style>

<style lang='scss'>
  #caregiver-history-table {
    tr {
      &:hover {
        & > td {
          background: #FFF !important;
        }
      }
    }

    .el-tooltip {
      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
